const routes = [
    {
        path: '/crossdocking/diferpan/produtos',
        name: 'crossdocking.products.diferpan.list',
        component: () => import('@/modules/crossdokking/views/diferpan/ProductsList.vue'),
        meta: {
            env: ['production'],
            pageTitle: 'Produtos Diferpan',
            roles: [1, 2, 5, 6],
            breadcrumb: [
                {
                    text: 'Listar',
                    active: true,
                },
            ],
        },
    }
]

export default routes
